import { Button, Stack, Typography, styled } from '@mui/material';
import { IconsCloses } from '../Components/icons/IconsCloses';
import { IconsError } from '../Components/icons/IconsError';
import { IconsSuecces } from '../Components/icons/IconsSuecces';
import { IconsWarning } from '../Components/icons/IconsWarning';

const HeaderNotification = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  maxHeight: '79px',
  minHeight: '79px',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
}));

const ContentHeader = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  flex: '1',
  margin: '0px',
  width: '100%',
  padding: '0 1.30rem',
});

const TextFieldNotification = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.white.main,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: 'clamp(1rem, 0.0344rem + 3.0534vw, 1.5rem);',
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  margin: '0px',
}));

const TitletNotificacion = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'start',
  gap: '1rem',
});

const CloseButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
  margin: '0px',
  backgroundColor: 'transparent',
  height: '30px',
  width: '20px',
  ':hover': {
    background: theme.palette.action.hover,
  },
}));

const handlerIcons = textIcons => {
  return textIcons === 'success' ? (
    <IconsSuecces />
  ) : textIcons === 'warning' ? (
    <IconsWarning />
  ) : (
    textIcons === 'error' && (
      <img
        src='/assets/images/maintenancetriangle.svg'
        alt='error'
        style={{ width: 44, height: 44 }}
      />
    )
  );
};

const handleTitle = (typeNotification = 'success', titleNotification) => {
  return typeNotification !== 'success' ? '¡Algo salió mal!' : titleNotification;
};

export const NotificationsHeaders = ({
  iconsNotification = 'success',
  titleNotification = 'Notificaciones Tittle Success',
  handlerClickCloses,
  typeNotification,
}) => {
  return (
    <HeaderNotification>
      <ContentHeader>
        <TitletNotificacion flex={'1 1 auto'}>
          {handlerIcons(iconsNotification)}
          <TextFieldNotification>
            {handleTitle(iconsNotification, titleNotification)}
          </TextFieldNotification>
        </TitletNotificacion>
        <CloseButton sx={{ display: { md: 'flex', sm: 'none' } }} onClick={handlerClickCloses}>
          <IconsCloses />
        </CloseButton>
      </ContentHeader>
    </HeaderNotification>
  );
};
